import React from 'react';

import { Box, Skeleton, Stack, Typography } from '@mui/material';

import Icons from '../../../../themes/icons';
import Button from '../../../Button/Button';
import { useCreateInvite } from '../../../Dialogs/CreateInvite/context/CreateInvite.context';

type Props = {
  onCollabBack?: () => void;
};

export const SentSuccessfully: React.FC<Props> = ({ onCollabBack }) => {
  const { mutation } = useCreateInvite();

  return (
    <Box sx={{ borderRadius: '12px', border: '1px solid #F1F2F1', padding: '42px 52px' }}>
      {mutation.isPending ? (
        <Stack spacing={2}>
          <Skeleton variant='circular' width={100} height={100} />
          <Skeleton variant='rounded' width={150} />
          <Skeleton variant='rounded' width={420} height={10} />
          <Skeleton variant='rounded' width={370} height={10} />
          <Skeleton variant='rounded' width={320} height={10} />
          <Skeleton variant='rounded' width={150} height={40} />
        </Stack>
      ) : (
        <Box maxWidth={'480px'}>
          <Stack spacing={4}>
            <Icons.Sent2xIcon />
            <Box display={'flex'} flexDirection={'column'} gap={'6px'}>
              <Typography sx={{ fontFamily: 'Poppins', fontSize: '24px', fontWeight: 500 }}>
                Collab sent successfully!
              </Typography>
              <Typography sx={{ fontFamily: 'Poppins', fontSize: '15px', fontWeight: 300 }}>
                <Typography component={'span'} sx={{ fontWeight: 400 }}>
                  Your payment will be held for 72 hours.
                </Typography>{' '}
                If the invitees do not accept your collaboration, you will receive your money back.
              </Typography>
            </Box>
            <Button
              variant='contained'
              color='primary'
              fullWidth={false}
              onClick={onCollabBack}
              sx={{ py: 1.5, px: 1, maxWidth: '250px' }}
            >
              Go back to collabs
            </Button>
          </Stack>
        </Box>
      )}
    </Box>
  );
};
